import { render, staticRenderFns } from "./GreenCardList.vue?vue&type=template&id=416c7876&scoped=true&"
import script from "./GreenCardList.vue?vue&type=script&lang=ts&"
export * from "./GreenCardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c7876",
  null
  
)

export default component.exports